/**
 * @author       calvin@zumper.com (Calvin Yau)
 * @copyright    Copyright (c) 2019, Zumper
 * @description  Filters meta reducer
 */

import { combineReducers } from 'redux'
import { combineActions, handleActions } from 'redux-actions'

import {
  CANCEL_FETCHING_LISTABLES_COUNT,
  CLEAR_LISTABLES_COUNT,
  DONE_FETCHING_LISTABLES_COUNT,
  ERROR_FETCHING_LISTABLES_COUNT,
  START_FETCHING_LISTABLES_COUNT,
} from '../constants/index'

const metaReducer = combineReducers({
  fetching: handleActions(
    {
      [START_FETCHING_LISTABLES_COUNT]: () => true,
      [combineActions(CANCEL_FETCHING_LISTABLES_COUNT, DONE_FETCHING_LISTABLES_COUNT)]: () => false,
    },
    false
  ),
  fetchingKey: handleActions(
    {
      [START_FETCHING_LISTABLES_COUNT]: (_, action) => action.payload,
      [combineActions(CANCEL_FETCHING_LISTABLES_COUNT, DONE_FETCHING_LISTABLES_COUNT)]: () => null,
    },
    null
  ),
  error: handleActions(
    {
      [ERROR_FETCHING_LISTABLES_COUNT]: (_, action) => action.payload,
      [combineActions(START_FETCHING_LISTABLES_COUNT, CLEAR_LISTABLES_COUNT)]: () => null,
    },
    null
  ),
})

export default metaReducer
